import { render, staticRenderFns } from "./modal_tag_list.vue?vue&type=template&id=46580a08&scoped=true&"
import script from "./modal_tag_list.vue?vue&type=script&lang=js&"
export * from "./modal_tag_list.vue?vue&type=script&lang=js&"
import style0 from "./modal_tag_list.vue?vue&type=style&index=0&id=46580a08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46580a08",
  null
  
)

export default component.exports